import { Injectable } from '@angular/core';
import { Learner } from '../models/Learner';
import { ApiLearnerService } from '../api-services/learner.api';
import { AlertController } from '@ionic/angular';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { MessagesService } from './messages.service';
import { CryptoService } from './crypto.service';

@Injectable({
    providedIn: 'root'
})
export class LearnerService {

    public learners: Learner[] = [];
    public learnersCopy: Learner[] = [];

    public learnerFilter = {
        username: '',
        firstName: '',
        lastName: '',
        email: '',
      };

    constructor(
        public learnerApiService: ApiLearnerService,
        public alertController: AlertController, 
        public messagesService: MessagesService,
        public cryptoService: CryptoService
    ) { 
        this.getLearnersByCustomerId();
    }

    async addLearner(learner){
        await this.messagesService.presentLoadingWindow("Adding Learner...");
        this.learnerApiService.addLearner(learner).subscribe(x=>{
            this.getLearnersByCustomerId().then(x=>{
                this.messagesService.loadingWindow.dismiss();
                this.messagesService.addedSuccessfully("Learner");
            });
        });
    }

    async updateLearner(learner : Learner){
        await this.messagesService.presentLoadingWindow("Updating Learner...");
        this.learnerApiService.updateLearner(learner.learnerId,learner).subscribe(x=>{
            this.getLearnersByCustomerId().then(x=>{
                this.messagesService.loadingWindow.dismiss();
                this.messagesService.updatedSuccessfully("Learner");
            });
        });
    }

    async deleteLearner(learner:Learner) {
        const alert = await this.alertController.create({
          header: 'Please confirm',
          message: "are you sure you want to delete this learner?",
          buttons: [{
            text: 'Cancel',
          }, {
            text: 'Delete',
            handler: () => {
              this.messagesService.presentLoadingWindow("Deleting Learner...");
              this.learnerApiService.deleteLearner(learner.learnerId).subscribe(res => {
                  this.getLearnersByCustomerId().then(x=>{
                    this.messagesService.loadingWindow.dismiss();
                  });
                
              });
              this.messagesService.deletedSuccessfully("Learner");
            }
          }
          ]
        });
        await alert.present();
      }

    getLearnersByCustomerId() {
        return new Promise<void>((resolve) => {
            this.learnerApiService.getLearnerByCustomerId(+this.cryptoService.decryptData(localStorage.getItem('customerId'))).subscribe(savedLearners => {
                this.learners = savedLearners;
                this.learnersCopy = savedLearners;
                resolve();
            });
        });
    }

    reinitLearners(){
        this.learners = this.learnersCopy;
    }
}